import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../colorVars';
import { useMouseCoordinates } from './MouseCoordinatesWrapper';

const ChartCrossHairs = ({
  size,
  bottomPadding,
}) => {
  const { coordinates, showCrossHairs } = useMouseCoordinates();
  const [x, y] = coordinates;

  return (
    <g>
      {showCrossHairs && (
        <>
          <line
            strokeDasharray="1, 1"
            x1={0}
            x2={size}
            y1={y}
            y2={y}
            stroke={colors.white}
          />
          <line
            strokeDasharray="1, 1"
            y1={0}
            y2={size + bottomPadding}
            x1={x}
            x2={x}
            stroke={colors.white}
          />
        </>
      )}
    </g>
  );
};

ChartCrossHairs.propTypes = {
  coordinates: PropTypes.array,
  setCoordinates: PropTypes.func,
  setShowCrossHairs: PropTypes.func,
  showCrossHairs: PropTypes.bool,
  size: PropTypes.number,
  bottomPadding: PropTypes.number,
  svgRef: PropTypes.shape({
    current: PropTypes.object
  })
};

export default ChartCrossHairs;
